// extracted by mini-css-extract-plugin
export default {"wrapper":"rvz3PQF3dte929YEL94y","leftSideContentWrapper":"EA4D3itmq_3FDOV_wkPo","mainContentWrapper":"pniDxZ2yCxGrn1LFeUOw"};